import { render, staticRenderFns } from "./DtePageHeaderSection.vue?vue&type=template&id=20bc8012"
import script from "./DtePageHeaderSection.vue?vue&type=script&lang=js"
export * from "./DtePageHeaderSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports